module.exports = __webpack_public_path__ + "/bundle/asset/revision2-83ba45f36c8f064b5efaddaddac6cb32.png";